export const ORGANIZATION = 'ORGANIZATION'
export const ROLEPERMISSION = 'ROLEPERMISSION'